import store from "../store";
import {UserStateInfo} from "../store/reducers";

export function getUser() : UserStateInfo {
  return store.getState().user;
}
